import React from "react";
import '../CSS/memories.css';
function Memories () {
    return(
        <div>
            <h2 className="title">Coming soon...</h2>
        </div>
    )
}
export default Memories;